import {
    GET_ROLES,
    GET_ROLES_SUCCESS,
} from './constants';

/**
 *
 * @returns {{type: string}}
 */
const getRoles = () => (
    { 
        type: GET_ROLES
    }
);

/**
 *
 * @param roles
 * @returns {{roles: *, type: string}}
 */
const getRolesSuccess = (roles) => ( {
    type: GET_ROLES_SUCCESS,
    roles
} );

export {
    getRoles,
    getRolesSuccess
};